import { render } from "./EtcList.vue?vue&type=template&id=533b74a5"
import script from "./EtcList.vue?vue&type=script&lang=js"
export * from "./EtcList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__